module.exports = __webpack_public_path__ + "img/fossilImg2.6bd4c9c8.jpg";